export default __webpack_public_path__ + "static/media/welcome-bg12.2c91eb59.png";